app.service('unavailableItemsModal', function (orderConfig, modal, loading) {

	var config;

	function removeUnavailableProducts() {
		loading.start();
		$.ajax({
			url: 'order-remove-unavailable-products.ltr',
			type: 'POST',
			success: function () {
				loading.redirect({
					href: "/cart.bhtml",
					soft: true
				});
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd usuwania produktów niedostępnych');
			}
		});
	}

	function checkStatus() {
		if (config && config.unavailableItems) {
			open();
			return true;
		}
		return false;
	}

	function open() {
		modal.open('unavailable-items');
	}

	function init() {
		config = orderConfig.getData();

		$('.js-remove-unavailable-products').click(function () {
			removeUnavailableProducts();
		});

		if (config && config.unavailableItems) {
			open();
		}
	}

	return {
		init,
		checkStatus,
	};
});
